var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1 4.5C16.1 5 15.7 5.4 15.2 5.4C14.7 5.4 14.3 5 14.3 4.5C14.3 4 14.7 3.6 15.2 3.6C15.7 3.6 16.1 4 16.1 4.5ZM5.2 1.4C5.3 1.4 5.4 1.3 5.4 1.2V0.7C5.4 0.6 5.3 0.5 5.2 0.5H3.8C3.7 0.5 3.6 0.6 3.6 0.7V1.2C3.6 1.3 3.7 1.4 3.8 1.4H5.2ZM10.3 11.7002C12.5 11.7002 14.3 9.9002 14.3 7.70019C14.3 5.50019 12.5 3.70019 10.3 3.70019C8.09999 3.70019 6.29999 5.50019 6.29999 7.70019C6.29999 9.9002 8.09999 11.7002 10.3 11.7002ZM10.3 4.5C12 4.5 13.4 5.9 13.4 7.6C13.4 9.3 12 10.7 10.3 10.7C8.6 10.7 7.2 9.3 7.2 7.6C7.2 5.9 8.6 4.5 10.3 4.5ZM0 3.6V12.6C0 14.4 1.8 14.4 1.8 14.4H17.9C17.9 14.4 19.7 14.4 19.7 12.6V3.6C19.7 1.8 17.9 1.8 17.9 1.8H14.5L13.5 0.2C13.4 0.1 13.3 0 13.2 0H7.4C7.3 0 7.1 0.1 7 0.2L6.1 1.8H1.8C1.8 1.8 0 1.8 0 3.6ZM6.7 2.7L7.7 0.9H12.8L13.9 2.7H17.8C17.8 2.7 18.7 2.7 18.7 3.6V12.6C18.7 13.5 17.8 13.5 17.8 13.5H1.7C1.7 13.5 0.8 13.5 0.8 12.6V3.7C0.8 2.8 1.7 2.8 1.7 2.8H6.7V2.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCamera);
export default __webpack_public_path__ + "static/media/media-camera.be9178b85b8d3c251f8a5f511ea57227.svg";
export { ForwardRef as ReactComponent };